import script from "./ConversationsOverTimeChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ConversationsOverTimeChart.vue?vue&type=script&setup=true&lang=js"

import "./ConversationsOverTimeChart.vue?vue&type=style&index=0&id=6efcc7df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6efcc7df"]])

export default __exports__